/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  nasledujiciWidgetTitle: {
    id: "b2b.fixniNaroky.nasledujiciWidgetTitle",
    defaultMessage: "Fixní nároky"
  },
  nasledujiciWidgetTitleDescription: {
    id: "b2b.fixniNaroky.nasledujiciWidgetTitleDescription",
    defaultMessage: "NA NÁSLEDUJÍCÍ TÝDEN"
  },
  nasledujiciItemSmlouva: {
    id: "b2b.fixniNaroky.nasledujiciItemSmlouva",
    defaultMessage: "Smlouva"
  },
  nasledujiciCountTitleVzo: {
    id: "b2b.fixniNaroky.nasledujiciCountTitleVzo",
    defaultMessage: "VZO"
  },
  nasledujiciCountTitleMzo: {
    id: "b2b.fixniNaroky.nasledujiciCountTitleMzo",
    defaultMessage: "MZO"
  }
});

export default () => useMessages(MESSAGES);
